(ns machtfit.dashboard.stepchall.form.core
  (:require [machtfit.dashboard-widgets :as widgets]
            [machtfit.dashboard.stepchall.form.duration :as duration]
            [machtfit.dashboard.stepchall.form.name :as name]
            [machtfit.dashboard.stepchall.form.route :as route]
            [machtfit.dashboard.stepchall.form.test-data :as test-data]
            [machtfit.dashboard.stepchall.form.unit :as unit]
            [machtfit.datetime :as datetime]
            [re-frame.core :as rf]))

(rf/reg-sub ::effective-edit-mode
  :<- [:get [:ui :stepchall :route-edit :enabled?]]
  :<- [:get [:ui :stepchall :route-edit :key-modifiers]]

  (fn [[edit-mode-enabled? {:keys [shift?]}] _]
    (when edit-mode-enabled?
      (if shift?
        :add-or-remove
        :edit))))

(defn- db->challenge [db]
  (-> db
      :challenge
      (update :team-building-start datetime/date-string->iso-date)
      (update :challenge-start datetime/date-string->iso-date)
      (update :challenge-end datetime/date-string->iso-date)
      (update-in [:config :stages] (fn [stages]
                                     (mapv #(dissoc % :id) stages)))))

(rf/reg-event-fx ::save-challenge
  (fn [{:keys [db]} _]
    {:post {:url (-> db :io :save-url)
            :csrf-token (-> db :io :csrf-token)
            :data (clj->js (db->challenge db))
            :on-success #(rf/dispatch [::save-challenge-success %])
            :on-error #(rf/dispatch [::save-challenge-error %])}}))

(rf/reg-event-fx ::cancel-editing
  (fn [{:keys [db]} _]
    {:redirect {:url (-> db :ui :cancel-url)}}))

(rf/reg-event-fx ::save-challenge-success
  (fn [_ [_ result]]
    {:redirect {:url (:redirect-url result)}}))

(rf/reg-event-fx ::save-challenge-error
  (fn [{:keys [db]} [_ result]]
    {:db (let [errors (:errors (:response result))]
           (assoc db :errors
                  (if (empty? errors)
                    ["Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut. Wenn der Fehler weiterhin auftritt, kontaktieren Sie bitte machtfit."]
                    errors)))
     :scroll-to {:mode :page-top}}))

(defn- section-errors []
  (when-let [errors @(rf/subscribe [:get [:errors]])]
    [widgets/section
     {:title "Fehler"
      :subtitle "Bitte korrigieren Sie:"
      :content [:div>div.col.s11.offset-s1
                [widgets/error-messages errors]]}]))

(defn- product []
  (when-let [choices-url @(rf/subscribe [:get [:io :product-choices-url]])]
    [:div.col.s12 {:style {:margin-bottom "1rem"}}
     [widgets/block-select
      {:id "product"
       :label-text "Firmenangebot"
       :value @(rf/subscribe [:get [:challenge :product]])
       :lookup-url choices-url
       :shown-entries 5
       :on-save #(rf/dispatch [:set-path [:challenge :product] %])
       :block-style {:width "50%"}}]]))

(defn- feedback-url []
  [:div.col.s12 {:style {:margin-bottom "1rem"}}
   [widgets/block-input2
    {:id "feedback-url"
     :label-text "Umfrage-URL"
     :placeholder "Bitte geben Sie einen URL für eine Umfrage ein"
     :value @(rf/subscribe [:get [:challenge :feedback-url]])
     :on-save #(rf/dispatch [:set-path [:challenge :feedback-url] %])
     :block-style {:width "100%"}}]])

(rf/reg-event-db ::toggle-active?
  (fn [db _]
    (update-in db [:challenge :active?] not)))

(rf/reg-event-db ::toggle-on-top-of-start-page?
  (fn [db _]
    (update-in db [:challenge :on-top-of-start-page?] not)))

(rf/reg-event-db ::toggle-allow-automatic-step-tracking?
  (fn [db _]
    (update-in db [:challenge :config :allow-automatic-step-tracking?] not)))

(defn- section-general []
  [widgets/section
   {:anchor "general"
    :title "Daten"
    :content [:div
              [product]
              [widgets/checkbox
               {:checked? @(rf/subscribe [:get [:challenge :active?]])
                :on-save #(rf/dispatch [::toggle-active? %])
                :label-text "Ist aktiv"}]
              [widgets/checkbox
               {:checked? @(rf/subscribe [:get [:challenge :on-top-of-start-page?]])
                :on-save #(rf/dispatch [::toggle-on-top-of-start-page? %])
                :label-text "Oben auf der Startseite anzeigen"}]
              [widgets/checkbox
               {:checked? @(rf/subscribe [:get [:challenge :config :allow-automatic-step-tracking?]])
                :on-save #(rf/dispatch [::toggle-allow-automatic-step-tracking? %])
                :label-text "Automatische Schritterfassung erlauben"}]
              [feedback-url]]}])

(defn- section-save []
  [widgets/section
   {:anchor "save"
    :title "Speichern"
    :content [:div
              [:div.col.s8
               [:a.waves-effect.waves-light.btn
                {:on-click #(rf/dispatch [::save-challenge])}
                "Speichern"]]
              [:div.col.s4
               [:button.waves-effect.btn.btn-flat
                {:on-click #(rf/dispatch [::cancel-editing])}
                [:i.material-icons.left "cancel"] "Abbrechen"]]]}])

(defn- section-teams []
  [widgets/section
   {:anchor "teams"
    :title "Teams"
    :content [:div.grid.grid-cols-1.gap-4
              [:div.mb-2
               [widgets/input-with-label
                {:required? false
                 :value @(rf/subscribe [:get [:challenge :config :min-team-size]])
                 :label-text "Team-Mindestgröße"
                 :type widgets/type-positive-number-or-nil
                 :on-save #(rf/dispatch [:set-path [:challenge :config :min-team-size] %])}]]
              [:div
               [widgets/input-with-label
                {:required? false
                 :value @(rf/subscribe [:get [:challenge :config :max-team-size]])
                 :label-text "Team-Maximalgröße"
                 :type widgets/type-positive-number-or-nil
                 :on-save #(rf/dispatch [:set-path [:challenge :config :max-team-size] %])}]]]}])

(defn stepchall-edit []
  [:div.container {:style {:width "95%"}}
   [test-data/section-test-data]
   [section-errors]
   [section-general]
   [name/section-name]
   [unit/section-unit]
   [section-teams]
   [duration/section-duration]
   [route/section-route]
   [section-save]])

(rf/reg-event-db ::init
  (fn [db [_ {:keys [challenge io ui]}]]
    (assoc db
           :io io
           :ui ui
           :challenge (-> challenge
                          (update :team-building-start datetime/iso-date->date-string)
                          (update :challenge-start datetime/iso-date->date-string)
                          (update :challenge-end datetime/iso-date->date-string)
                          (update-in [:config :stages] #(mapv route/add-random-id %))
                          (update-in [:config :stages] route/sort-stages)))))

(defn ^:export load [js-challenge-form-data]
  (rf/dispatch [::init (js->clj js-challenge-form-data :keywordize-keys true)]))
